import { gql } from '@apollo/client';

export const CREATE_WORKSPACE = gql`
mutation Mutation($input: CreateWorkspaceInput!) {
    createWorkspace(input: $input) {
      id
      name
      handle
      createdAt
      updatedAt
      subscription
      createdBy
      updatedBy
    }
  }
`;

export const GET_WORKSPACE = gql`
  query GetWorkspace($input: getWorkspaceInput) {
    getWorkspace(input: $input) {
      id
      name
      handle
      createdAt
      updatedAt
      subscription
      logo
      userCount
      createdBy
      updatedBy
    }
}
`;

export const CREATE_WORKSPACE_PROFILE = gql`
  mutation Mutation($input: CreateWorkspaceProfileInput!) {
    createWorkspaceProfile(input: $input) {
      id
      workspaceId
      userId
      displayName
      isActive
      lastActive
      createdAt
      createdBy
      updatedAt
      updatedBy
    }
  }
`;

export const GET_USER_WORKSPACES = gql`
query Query($userId: ID!, $limit: Int, $offset: Int) {
  listWorkspace(userId: $userId, limit: $limit, offset: $offset) {
    id
    logo
    userCount
    updatedBy
    updatedAt
    subscription
    name
    handle
    isDisabled
    createdBy
    createdAt
  }
}
`;

export const UPDATE_MEDIA_LOGO = gql`
  mutation UpdateMediaLogo($type: LogoType!, $fileType: FileType!, $workspaceId: Int, $userId: Int, $workspaceProfileId: Int) {
    updateMediaLogo(type: $type, fileType: $fileType, workspaceId: $workspaceId, userId: $userId, workspaceProfileId: $workspaceProfileId) {
      message
      type
      logo
    }
  }
`;

export const DELETE_MEDIA_LOGO = gql`
  mutation DeleteMediaLogo($type: LogoType!, $workspaceId: Int, $userId: Int, $workspaceProfileId: Int) {
    deleteMediaLogo(type: $type, workspaceId: $workspaceId, userId: $userId, workspaceProfileId: $workspaceProfileId) {
      message
      type
    }
  }
`;

export const GET_HANDLE_SUGGESTIONS = gql`
  query GetHandleSuggestions($handle: String!, $limit: Int) {
    getHandleSuggestions(handle: $handle, limit: $limit) {
      status
      suggestions
    }
  }
`;

export const UPDATE_WORKSPACE = gql`
  mutation UpdateWorkspace($input: UpdateWorkspaceInput!) {
    updateWorkspace(input: $input) {
      id
      name
      handle
      createdAt
      updatedAt
      subscription
      logo
      userCount
      createdBy
      updatedBy
    }
  }
`;

export const UPDATE_WORKSPACE_PROFILE = gql`
  mutation UpdateWorkspaceProfile($input: UpdateWorkspaceProfileInput!) {
    updateWorkspaceProfile(input: $input) {
      id
      workspaceId
      userId
      logo
      displayName
      isActive
      lastActive
      roleId
      createdAt
      createdBy
      updatedAt
      updatedBy
    }
  }
`;

export const GET_WORKSPACE_PROFILE = gql`
  query GetWorkspaceProfile($input: WorkspaceProfileInput) {
    getWorkspaceProfile(input: $input) {
      id
      workspaceId
      userId
      logo
      displayName
      isActive
      lastActive
      roleId
      createdAt
      createdBy
      updatedAt
      updatedBy
    }
  }
`;

export const DELETE_WORKSPACE_PROFILE = gql`
  mutation DeleteWorkspaceProfile($input: DeleteWorkspaceProfileInput!) {
    deleteWorkspaceProfile(input: $input) {
      message
      type
    }
  }
`;

export const GET_WORKSPACE_PROFILES = gql`
  query ListWorkspaceProfiles($workspaceId: Int!) {
    listWorkspaceProfiles(workspaceId: $workspaceId) {
      id
      workspaceId
      userId
      logo
      displayName
      isActive
      lastActive
      roleId
      createdAt
      createdBy
      updatedAt
      updatedBy
      isDisabled
      userWorkspace {
        email
      }
    }
  }
`;

export const GET_WORKSPACE_INVITES = gql`
  query ListWorkspaceInvites($workspaceId: Int!) {
    listWorkspaceInvites(workspaceId: $workspaceId) {
      id
      workspaceId
      email
      role
      link
      isActive
      accepted
      count
      createdAt
      createdBy
      updatedAt
      updatedBy
    }
  }
`;

export const GET_WORKSPACE_INVITES_BY_EMAIL = gql`
  query ListWorkspaceInviteByEmail($email: String!) {
    listWorkspaceInviteByEmail(email: $email) {
      id
      workspaceId
      email
      role
      link
      isActive
      accepted
      count
      createdAt
      createdBy
      createdByEmail
      updatedAt
      updatedBy
      workspaceMetadata {
        name
        logo
        workspaceMembers
      }
    }
  }
`;

export const CREATE_WORKSPACE_INVITES = gql`
  mutation CreateWorkspaceInvites($workspaceId: Int!, $input: [CreateWorkspaceInviteInput]!) {
    createWorkspaceInvites(workspaceId: $workspaceId, input: $input) {
      id
      workspaceId
      email
      role
      link
      isActive
      accepted
      count
      createdAt
      createdBy
      updatedAt
      updatedBy
    }
  }
`;

export const DELETE_WORKSPACE_INVITE = gql`
  mutation DeleteWorkspaceInvite($input: DeleteWorkspaceInviteInput!) {
    deleteWorkspaceInvite(input: $input) {
      message
      type
    }
  }
`;

export const UPDATE_WORKSPACE_INVITE = gql`
  mutation UpdateWorkspaceInvite($input: UpdateWorkspaceInviteInput!) {
    updateWorkspaceInvite(input: $input) {
      id
      workspaceId
      email
      role
      link
      isActive
      accepted
      count
      createdAt
      createdBy
      updatedAt
      updatedBy
    }
  }
`;

export const VERIFY_WORKSPACE_INVITE = gql`
  query VerifyWorkspaceInvite($token: String!, $email: String) {
    verifyWorkspaceInvite(token: $token, email: $email) {
      message
      type
    }
  }
`;
